(function () {
  'use strict';
  var groupKeys = ['perf', 'gen', 'casa'];
  var occasionHandles = ['todos-los-dias', 'una-cita', 'algo-especial'];

  function normalize(value) {
    return String(value || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function hasSelections(selection) {
    return groupKeys.some(function (group) { return selection[group].size > 0; });
  }
  function canonicalSelectionUrl(currentUrl) {
    var destination = new URL(currentUrl);
    var legacy = { nicho: ['perf', 'nicho'], disenador: ['perf', 'disenador'], hombre: ['gen', 'masculino'], mujer: ['gen', 'femenino'], unisex: ['gen', 'unisex'] };
    var imported = { perf: new Set(), gen: new Set() };
    var remaining = [];
    var changed = false;
    destination.searchParams.getAll('filter.p.tag').forEach(function (tag) {
      var match = legacy[normalize(tag)];
      if (!match) { remaining.push(tag); return; }
      imported[match[0]].add(match[1]);
      changed = true;
    });
    if (!changed) return destination;
    destination.searchParams.delete('filter.p.tag');
    remaining.forEach(function (tag) { destination.searchParams.append('filter.p.tag', tag); });
    ['perf', 'gen'].forEach(function (group) {
      if (imported[group].size && !destination.searchParams.has('alp_' + group)) destination.searchParams.set('alp_' + group, Array.from(imported[group]).join(','));
    });
    destination.searchParams.delete('page');
    return destination;
  }
  function safeCollectionUrl(value, currentUrl) {
    try {
      if (!value) return null;
      var current = new URL(currentUrl);
      var destination = new URL(value, current);
      if (destination.origin !== current.origin || destination.username || destination.password || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\/[a-z0-9][a-z0-9-]*(?:\/[a-z0-9%+_-]+)?\/?$/i.test(destination.pathname)) return null;
      Array.from(destination.searchParams.keys()).forEach(function (key) {
        if (!/^(?:filter\.[a-z0-9_.]+|alp_(?:perf|gen|casa)|sort_by|page|preview_theme_id|pb)$/.test(key)) destination.searchParams.delete(key);
      });
      destination.hash = 'aoc-products';
      return destination;
    } catch (_) { return null; }
  }
  function isOccasionUrl(url) {
    var parts = url.pathname.split('/');
    return occasionHandles.indexOf(parts[parts.indexOf('collections') + 1]) !== -1;
  }
  function resolveReturnContext(currentUrl, referrer, stored, now) {
    var current = safeCollectionUrl(currentUrl, currentUrl);
    if (!current || !isOccasionUrl(current)) return null;
    var previous = safeCollectionUrl(referrer, currentUrl);
    if (!previous) return null;
    if (!isOccasionUrl(previous)) return { url: previous.href, entry: current.pathname, time: now };
    if (!stored || stored.entry !== current.pathname || typeof stored.time !== 'number' || now - stored.time > 1800000 || now < stored.time) return null;
    var origin = safeCollectionUrl(stored.url, currentUrl);
    if (!origin || isOccasionUrl(origin)) return null;
    return { url: origin.href, entry: current.pathname, time: stored.time };
  }
  function matchesRecord(record, selection, aliases, onlyPerf) {
    return (onlyPerf ? ['perf'] : groupKeys).every(function (group) {
      var values = selection[group];
      if (!values.size) return true;
      if (group === 'casa') return values.has(record.houseKey);
      return Array.from(values).some(function (value) {
        return (aliases[group][value] || []).some(function (tag) { return record.tags.has(tag); });
      });
    });
  }
  function selectionUrl(currentUrl, selection, nativePage) {
    var destination = new URL(currentUrl);
    groupKeys.forEach(function (group) {
      var name = 'alp_' + group;
      if (selection[group].size) destination.searchParams.set(name, Array.from(selection[group]).join(','));
      else destination.searchParams.delete(name);
    });
    if (!hasSelections(selection) && nativePage) destination.searchParams.set('page', nativePage);
    else destination.searchParams.delete('page');
    return destination;
  }
  function catalogUrl(collectionUrl, currentUrl, sectionId) {
    var current = new URL(currentUrl);
    var destination = new URL(collectionUrl, current);
    if (destination.origin !== current.origin) throw new Error('Invalid collection origin');
    var collectionPath = destination.pathname.replace(/\/$/, '');
    if (current.pathname === collectionPath || current.pathname.indexOf(collectionPath + '/') === 0) destination.pathname = current.pathname;
    destination.search = '';
    current.searchParams.forEach(function (value, key) {
      if (key.indexOf('filter.') === 0 || key === 'sort_by' || key === 'preview_theme_id') destination.searchParams.append(key, value);
    });
    destination.searchParams.set('section_id', sectionId);
    destination.hash = '';
    return destination;
  }
  function validatedNext(next, first) {
    var destination = new URL(next, first);
    if (destination.origin !== first.origin || destination.pathname.replace(/\/$/, '') !== first.pathname.replace(/\/$/, '')) throw new Error('Invalid catalog continuation');
    var protectedKeys = new Set();
    first.searchParams.forEach(function (_, key) { protectedKeys.add(key); });
    Array.from(destination.searchParams.keys()).forEach(function (key) {
      if (key.indexOf('filter.') === 0 || key === 'sort_by' || key === 'preview_theme_id' || key === 'section_id') destination.searchParams.delete(key);
    });
    protectedKeys.forEach(function (key) {
      destination.searchParams.delete(key);
      first.searchParams.getAll(key).forEach(function (value) { destination.searchParams.append(key, value); });
    });
    destination.hash = '';
    return destination;
  }
  function createCatalogLoader(firstUrl, loadPage) {
    var cachedPromise = null;
    return function () {
      if (cachedPromise) return cachedPromise;
      cachedPromise = (async function () {
        var first = new URL(firstUrl);
        var next = first;
        var seenPages = new Set();
        var seenProducts = new Set();
        var records = [];
        var expectedTotal = null;
        while (next) {
          if (seenPages.has(next.href)) throw new Error('Repeated catalog page');
          seenPages.add(next.href);
          var page = await loadPage(next.href);
          if (!page || !Array.isArray(page.records)) throw new Error('Invalid catalog response');
          if (page.total === undefined || page.total === null || String(page.total).trim() === '' || !Number.isSafeInteger(Number(page.total)) || Number(page.total) < 0) throw new Error('Invalid catalog total');
          var total = Number(page.total);
          if (expectedTotal !== null && total !== expectedTotal) throw new Error('Catalog total changed');
          expectedTotal = total;
          page.records.forEach(function (record) {
            if (!record || record.id === undefined || record.id === null || String(record.id).trim() === '') throw new Error('Invalid product identity');
            var id = String(record.id);
            if (seenProducts.has(id)) return;
            seenProducts.add(id);
            records.push(record);
          });
          if (records.length > expectedTotal) throw new Error('Invalid catalog size');
          next = page.next ? validatedNext(page.next, first) : null;
        }
        if (records.length !== expectedTotal) throw new Error('Incomplete catalog');
        return records;
      })().catch(function (error) {
        cachedPromise = null;
        throw error;
      });
      return cachedPromise;
    };
  }

  /* Export the production rules for local logic checks without a browser dependency. */
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { normalize: normalize, matchesRecord: matchesRecord, selectionUrl: selectionUrl, catalogUrl: catalogUrl, validatedNext: validatedNext, createCatalogLoader: createCatalogLoader, canonicalSelectionUrl: canonicalSelectionUrl, safeCollectionUrl: safeCollectionUrl, resolveReturnContext: resolveReturnContext };
    return;
  }
  if (window.__alpOccasions) return;
  window.__alpOccasions = true;
  var canonical = canonicalSelectionUrl(window.location.href);
  if (document.querySelector('[data-aoc-page]') && canonical.href !== window.location.href) {
    window.location.replace(canonical.href);
    return;
  }
  var initialized = new WeakSet();
  var restorers = new WeakMap();
  var reflectedSearch = window.location.search;
  var originStorageKey = 'alp-occasion-origin-v1';

  function readOrigin() {
    try { return JSON.parse(window.sessionStorage.getItem(originStorageKey) || 'null'); } catch (_) { return null; }
  }
  function saveOrigin(context) {
    try {
      if (context) window.sessionStorage.setItem(originStorageKey, JSON.stringify(context));
      else window.sessionStorage.removeItem(originStorageKey);
    } catch (_) { /* Collection links remain usable when storage is unavailable. */ }
  }
  function initReturn(root) {
    var link = root.querySelector('[data-aoc-return]');
    if (!link) return;
    var context = resolveReturnContext(window.location.href, document.referrer, readOrigin(), Date.now());
    saveOrigin(context);
    if (!context) return;
    link.href = context.url;
    link.hidden = false;
  }

  function initGroups(root) {
    var groups = root.querySelector('[data-aoc-groups]');
    var nativeResults = root.querySelector('[data-aoc-native-results]');
    var results = root.querySelector('[data-aoc-group-results]');
    var grid = root.querySelector('[data-aoc-filtered-grid]');
    var more = root.querySelector('[data-aoc-more]');
    var count = root.querySelector('.aoc-count');
    var status = root.querySelector('[data-aoc-status]');
    var chips = root.querySelector('[data-aoc-group-active]');
    var clear = root.querySelector('[data-aoc-groups-clear]');
    var empty = root.querySelector('[data-aoc-group-empty]');
    var houseOptions = root.querySelector('[data-aoc-house-options]');
    var houseSearch = root.querySelector('[data-aoc-house-search]');
    var houseEmpty = root.querySelector('[data-aoc-house-empty]');
    if (!groups || !nativeResults || !results || !grid || !count || !status || !chips || !clear || !empty || !houseOptions) return;

    var originalCount = count.textContent;
    var selection = { perf: new Set(), gen: new Set(), casa: new Set() };
    var aliases = { perf: {}, gen: {} };
    var labels = { perf: {}, gen: {}, casa: {} };
    var params = new URLSearchParams(window.location.search);
    var nativePage = params.get('page');
    var records = null;
    var filtered = [];
    var displayed = 0;
    var generation = 0;
    var housesBuilt = false;
    groups.querySelectorAll('input[data-aoc-group]').forEach(function (input) {
      var group = input.dataset.group;
      var key = normalize(input.value);
      if (group !== 'perf' && group !== 'gen') return;
      input.value = key;
      aliases[group][key] = (input.dataset.tags || '').split(',').map(normalize).filter(Boolean);
      labels[group][key] = input.dataset.label || input.closest('label').textContent.trim();
    });
    function readSelections() {
      var currentParams = new URLSearchParams(window.location.search);
      groupKeys.forEach(function (group) {
        selection[group].clear();
        (currentParams.get('alp_' + group) || '').split(',').map(normalize).filter(Boolean).forEach(function (key) {
          if (group === 'casa' || Object.prototype.hasOwnProperty.call(aliases[group], key)) selection[group].add(key);
        });
      });
    }
    readSelections();

    function textFor(name, fallback) { return groups.dataset[name] || fallback; }
    function setStatus(message, isError) {
      status.textContent = message;
      status.hidden = !message;
      status.classList.toggle('is-error', Boolean(isError));
      status.setAttribute('role', isError ? 'alert' : 'status');
    }
    function syncInputs() {
      groups.querySelectorAll('input[data-aoc-group]').forEach(function (input) {
        input.checked = Boolean(selection[input.dataset.group] && selection[input.dataset.group].has(normalize(input.value)));
      });
    }
    function persist(mode) {
      var destination = selectionUrl(window.location.href, selection, nativePage);
      if (destination.href !== window.location.href) window.history[mode === 'push' ? 'pushState' : 'replaceState'](window.history.state, '', destination.href);
      reflectedSearch = destination.search;
    }
    function renderChips() {
      chips.replaceChildren();
      groupKeys.forEach(function (group) {
        selection[group].forEach(function (key) {
          var label = labels[group][key] || key.replace(/-/g, ' ');
          var item = document.createElement(chips.tagName === 'UL' ? 'li' : 'span');
          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'aoc-group-chip';
          button.dataset.aocRemoveGroup = group;
          button.dataset.value = key;
          button.textContent = label + ' ×';
          button.setAttribute('aria-label', textFor('removeLabel', 'Quitar {label}').replace('{label}', label));
          item.appendChild(button);
          chips.appendChild(item);
        });
      });
      chips.hidden = !hasSelections(selection);
      clear.hidden = !hasSelections(selection);
      groups.querySelectorAll('[data-aoc-group-count]').forEach(function (badge) {
        var total = selection[badge.dataset.aocGroupCount].size;
        badge.textContent = String(total);
        badge.hidden = total === 0;
      });
    }
    function restoreNative() {
      nativeResults.hidden = false;
      results.hidden = true;
      empty.hidden = true;
      if (more) more.hidden = true;
      count.textContent = originalCount;
    }
    function updateHouses(pruneSelection) {
      if (!records) return false;
      if (!housesBuilt) {
        records.forEach(function (record) {
          if (record.houseKey && record.houseLabel) labels.casa[record.houseKey] = record.houseLabel;
        });
        Object.keys(labels.casa).sort(function (a, b) { return labels.casa[a].localeCompare(labels.casa[b], document.documentElement.lang || 'es', { sensitivity: 'base' }); }).forEach(function (key) {
          var label = document.createElement('label');
          label.className = 'aoc-group-option';
          var input = document.createElement('input');
          input.type = 'checkbox';
          input.value = key;
          input.dataset.aocGroup = '';
          input.dataset.group = 'casa';
          input.dataset.label = labels.casa[key];
          var name = document.createElement('span');
          name.textContent = labels.casa[key];
          label.append(input, name);
          houseOptions.appendChild(label);
        });
        housesBuilt = true;
      }
      var available = new Set(records.filter(function (record) { return matchesRecord(record, selection, aliases, true); }).map(function (record) { return record.houseKey; }));
      var pruned = false;
      if (pruneSelection === true) selection.casa.forEach(function (key) {
        if (!available.has(key)) { selection.casa.delete(key); pruned = true; }
      });
      var query = normalize(houseSearch ? houseSearch.value : '');
      var visible = 0;
      houseOptions.querySelectorAll('input[data-aoc-group]').forEach(function (input) {
        input.checked = selection.casa.has(input.value);
        var show = input.checked || (available.has(input.value) && (!query || normalize(labels.casa[input.value]).indexOf(query) !== -1));
        input.closest('.aoc-group-option').hidden = !show;
        if (show) visible += 1;
      });
      if (houseEmpty) {
        houseEmpty.textContent = textFor('houseEmptyLabel', 'No encontramos esa casa.');
        houseEmpty.hidden = visible !== 0;
      }
      return pruned;
    }
    function appendBatch(focusNew) {
      var fragment = document.createDocumentFragment();
      var end = Math.min(displayed + 24, filtered.length);
      var firstNew = null;
      for (var index = displayed; index < end; index += 1) {
        var card = filtered[index].node.cloneNode(true);
        if (!firstNew) firstNew = card;
        fragment.appendChild(card);
      }
      displayed = end;
      grid.appendChild(fragment);
      if (more) more.hidden = displayed >= filtered.length;
      if (focusNew && firstNew) {
        var link = firstNew.querySelector('a');
        if (link) link.focus({ preventScroll: true });
      }
    }

    var firstCatalogUrl = catalogUrl(groups.dataset.collectionUrl, window.location.href, groups.dataset.sectionId || 'alp-occasion-filter-catalog').href;
    var loadCatalog = createCatalogLoader(firstCatalogUrl, async function (url) {
      var controller = new AbortController();
      var timeout = window.setTimeout(function () { controller.abort(); }, 20000);
      try {
        var response = await window.fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' }, signal: controller.signal });
        if (!response.ok) throw new Error('Catalog HTTP ' + response.status);
        var parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        var catalog = parsed.querySelector('[data-aoc-catalog]');
        if (!catalog) throw new Error('Missing catalog section');
        var pageRecords = Array.from(catalog.querySelectorAll('[data-aoc-record]')).map(function (node) {
          var tags = JSON.parse(node.dataset.tags || '[]');
          if (!Array.isArray(tags)) throw new Error('Invalid product tags');
          node.querySelectorAll('script').forEach(function (script) { script.remove(); });
          var productLink = node.querySelector('a[href]');
          return {
            id: node.dataset.productId || (productLink ? productLink.getAttribute('href') : ''),
            tags: new Set(tags.map(normalize)),
            houseKey: normalize(node.dataset.houseKey),
            houseLabel: node.dataset.houseLabel || '',
            node: node
          };
        });
        return { records: pageRecords, next: catalog.dataset.next || '', total: catalog.dataset.total };
      } finally { window.clearTimeout(timeout); }
    });

    async function update(forceLoad, shouldPersist, pruneHouses) {
      var ticket = ++generation;
      var pruned = records ? updateHouses(pruneHouses) : false;
      syncInputs();
      if (shouldPersist || pruned) persist(shouldPersist ? 'push' : 'replace');
      renderChips();
      if (!hasSelections(selection) && !forceLoad) {
        restoreNative();
        setStatus('');
        return;
      }
      if (!records) {
        var loadingMessage = textFor('loadingLabel', 'Cargando perfumes…');
        setStatus(loadingMessage);
        if (houseEmpty) { houseEmpty.textContent = loadingMessage; houseEmpty.hidden = false; }
      }
      try {
        var fetched = records || await loadCatalog();
        if (ticket !== generation || !root.isConnected) return;
        records = fetched;
        pruned = updateHouses(pruneHouses);
        syncInputs();
        if (pruned) persist('replace');
        renderChips();
        if (!hasSelections(selection)) {
          restoreNative();
          setStatus('');
          return;
        }
        filtered = records.filter(function (record) { return matchesRecord(record, selection, aliases, false); });
        displayed = 0;
        grid.replaceChildren();
        appendBatch(false);
        nativeResults.hidden = true;
        results.hidden = false;
        empty.hidden = filtered.length !== 0;
        var countLabel = textFor(filtered.length === 1 ? 'countSingular' : 'countPlural', filtered.length === 1 ? '{count} perfume' : '{count} perfumes');
        count.textContent = countLabel.replace('{count}', String(filtered.length));
        setStatus(count.textContent);
      } catch (_) {
        if (ticket !== generation || !root.isConnected) return;
        restoreNative();
        var errorMessage = textFor('errorLabel', 'No pudimos cargar estos filtros. Inténtalo de nuevo; puedes seguir explorando la colección.');
        setStatus(errorMessage, true);
        if (houseEmpty) { houseEmpty.textContent = errorMessage; houseEmpty.hidden = false; }
      }
    }
    root.addEventListener('change', function (event) {
      var input = event.target;
      if (!input.matches || !input.matches('input[data-aoc-group]')) return;
      var group = input.dataset.group;
      if (groupKeys.indexOf(group) === -1) return;
      var key = normalize(input.value);
      if (input.checked) selection[group].add(key);
      else selection[group].delete(key);
      update(false, true, group === 'perf');
    });
    root.addEventListener('click', function (event) {
      var remove = event.target.closest('[data-aoc-remove-group]');
      if (remove && root.contains(remove)) {
        selection[remove.dataset.aocRemoveGroup].delete(remove.dataset.value);
        update(false, true);
      } else if (event.target.closest('[data-aoc-groups-clear]')) {
        groupKeys.forEach(function (group) { selection[group].clear(); });
        update(false, true);
      } else if (event.target.closest('[data-aoc-more]')) appendBatch(true);
    });
    var housePanel = groups.querySelector('[data-aoc-group-panel="casa"]');
    var panels = Array.from(groups.querySelectorAll('[data-aoc-group-panel]'));
    panels.forEach(function (panel) {
      panel.addEventListener('toggle', function () {
        if (!panel.open) return;
        panels.forEach(function (other) { if (other !== panel) other.open = false; });
        if (panel === housePanel) update(true, false);
      });
    });
    if (houseSearch) {
      houseSearch.addEventListener('focus', function () { if (!records) update(true, false); });
      houseSearch.addEventListener('input', function () { updateHouses(false); });
    }
    syncInputs();
    groups.hidden = false;
    restorers.set(root, function () {
      var currentCatalogUrl = catalogUrl(groups.dataset.collectionUrl, window.location.href, groups.dataset.sectionId || 'alp-occasion-filter-catalog').href;
      if (currentCatalogUrl !== firstCatalogUrl) return false;
      readSelections();
      var currentPage = new URLSearchParams(window.location.search).get('page') || '1';
      if (!hasSelections(selection) && currentPage !== (nativePage || '1')) return false;
      update(false, false);
      return true;
    });
    if (hasSelections(selection)) update(false, false);
  }

  function enhance(scope) {
    var roots = Array.from(scope.querySelectorAll('[data-aoc-page]'));
    if (scope.matches && scope.matches('[data-aoc-page]')) roots.unshift(scope);
    roots.forEach(function (root) {
      root.classList.add('aoc-enhanced');
      if (initialized.has(root)) return;
      initialized.add(root);
      initReturn(root);
      initGroups(root);
    });
  }
  document.addEventListener('change', function (event) {
    var select = event.target;
    if (!select.matches || !select.matches('[data-aoc-sort]') || !select.closest('.alp-occasions')) return;
    var destination = new URL(window.location.href);
    destination.searchParams.set('sort_by', select.value);
    destination.searchParams.delete('page');
    destination.hash = 'aoc-products';
    window.location.assign(destination.href);
  });
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('[data-aoc-filter-form], [data-aoc-sort-form]')) return;
    var params = new URLSearchParams(window.location.search);
    var represented = new Set(Array.from(form.querySelectorAll('[name]')).map(function (input) { return input.name; }));
    params.forEach(function (value, name) {
      if (name.indexOf('filter.') !== 0 || represented.has(name)) return;
      var preserved = document.createElement('input');
      preserved.type = 'hidden';
      preserved.name = name;
      preserved.value = value;
      form.appendChild(preserved);
    });
    ['preview_theme_id', 'alp_perf', 'alp_gen', 'alp_casa'].forEach(function (name) {
      form.querySelectorAll('input[name="' + name + '"]').forEach(function (input) { input.remove(); });
      var value = params.get(name);
      if (!value) return;
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    });
  });
  document.addEventListener('shopify:section:load', function (event) { enhance(event.target); });
  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href]');
    var destination = link ? safeCollectionUrl(link.href, window.location.href) : null;
    var current = safeCollectionUrl(window.location.href, window.location.href);
    if (destination && isOccasionUrl(destination) && current) {
      var context = isOccasionUrl(current) ? resolveReturnContext(window.location.href, document.referrer, readOrigin(), Date.now()) : { url: current.href, time: Date.now() };
      if (context) context.entry = destination.pathname;
      saveOrigin(context);
    }
    if (event.target.closest('.aoc-group-row')) return;
    document.querySelectorAll('[data-aoc-page] [data-aoc-group-panel][open]').forEach(function (panel) { panel.open = false; });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-aoc-page] [data-aoc-group-panel][open]').forEach(function (panel) {
      var hadFocus = panel.contains(document.activeElement);
      panel.open = false;
      if (hadFocus) panel.querySelector('summary').focus();
    });
  });
  function restoreHistory() {
    if (!document.querySelector('[data-aoc-page]') || window.location.search === reflectedSearch) return;
    var roots = Array.from(document.querySelectorAll('[data-aoc-page]'));
    var restored = roots.every(function (root) {
      var restore = restorers.get(root);
      return restore && restore();
    });
    if (!restored) window.location.reload();
    else reflectedSearch = window.location.search;
  }
  window.addEventListener('popstate', restoreHistory);
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) restoreHistory();
  });
  enhance(document);
})();

